import "./style.scss";
import { useRef, useState } from "react";
import { OfficeAccountingTableBody, OfficeAccountingTableHeader } from "@/src/constants/officeAccountingConsts";
import CellContent from "./CellContent/CellContent";
import VerticalLine from "../VerticalLine/VerticalLine";

const OAPLayout = () => {
  const [tableData, setTableData] = useState(OfficeAccountingTableBody);
  // ----------- HORIZONTAL SCROLL ----------- //
  const scrollRef = useRef<HTMLDivElement>(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const startScrollLeft = useRef(0);
  // onMouseDown
  const onMouseDown = (e: React.MouseEvent) => {
    if (!scrollRef.current) return;
    isDragging.current = true;
    startX.current = e.clientX;
    startScrollLeft.current = scrollRef.current.scrollLeft;
  };
  // onMouseMove
  const onMouseMove = (e: React.MouseEvent) => {
    if (!isDragging.current || !scrollRef.current) return;
    e.preventDefault();
    const dx = e.clientX - startX.current;
    scrollRef.current.scrollLeft = startScrollLeft.current - dx;
  };
  // onMouseLeave /onMouseUp
  const stopDrag = () => {
    isDragging.current = false;
  };
  // onTouchStart
  const onTouchStart = (e: React.TouchEvent) => {
    if (!scrollRef.current) return;
    startX.current = e.touches[0].clientX;
    startScrollLeft.current = scrollRef.current.scrollLeft;
  };
  // onTouchMove
  const onTouchMove = (e: React.TouchEvent) => {
    if (!scrollRef.current) return;
    const dx = e.touches[0].clientX - startX.current;
    scrollRef.current.scrollLeft = startScrollLeft.current - dx;
  };
  // ----------- HORIZONTAL SCROLL ----------- //
  return (
    <div className="container office-accounting">
      <div
        ref={scrollRef}
        className="office-accounting-table"
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={stopDrag}
        onMouseLeave={stopDrag}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
      >
        <table>
          <thead>
            <tr>
              {OfficeAccountingTableHeader.map((section, sectionIndex) =>
                Object.entries(section).map(([groupKey, columns]) =>
                  columns.map((column) => (
                    <th key={`${sectionIndex}-${groupKey}-${column.id}`} className={column.id} data-group={groupKey}>
                      <div className="cell-wrapper">
                        <p>{column.title}</p>
                        <div className="vertical-line">
                          <VerticalLine />
                        </div>
                      </div>
                    </th>
                  )),
                ),
              )}
            </tr>
          </thead>
          <tbody>
            {tableData.map((studentSections, studentIndex) => (
              <tr key={studentIndex}>
                {studentSections.map((section, sectionIndex) =>
                  Object.entries(section).map(([groupKey, columns]) =>
                    columns.map((column) => (
                      <td key={`${studentIndex}-${sectionIndex}-${groupKey}-${column.id}`} className={column.id} data-group={groupKey}>
                        <div className="cell-wrapper">
                          <CellContent
                            groupKey={groupKey}
                            column={column}
                            onChange={(newValue) => {
                              setTableData((prev) =>
                                prev.map((studentRow, sIndex) =>
                                  sIndex !== studentIndex
                                    ? studentRow
                                    : studentRow.map((section) => {
                                        if (!section[groupKey]) return section;
                                        return {
                                          ...section,
                                          [groupKey]: section[groupKey].map((col) =>
                                            col.id === column.id ? { ...col, value: newValue } : col,
                                          ),
                                        };
                                      }),
                                ),
                              );
                            }}
                          />
                          <div className="vertical-line">
                            <VerticalLine />
                          </div>
                        </div>
                      </td>
                    )),
                  ),
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OAPLayout;
